module.exports = __webpack_public_path__ + "static/media/areamap7.a2fd85ab.svg";